import React, { useContext } from "react";

export const ConfigContext = React.createContext<WebConfig>({
  graphqlAPI: "",
  appUrl: "",
  communityUrl: "",
  communityAdminUrl: "",
  diagnosticUrl: "",
  rudderstackURL: "",
  rudderstackWriteKeyWebApp: "",
  revision: "",
  oauthAppleRedirectUrl: "",
  oauthGoogleRedirectUrl: "",
  oauthLinkedinRedirectUrl: "",
  hubspotPortalId: "",
  API: "",
  environment: "",
  growthbookKey: "",
  googleApiKey: "",
  liveAvatarCoachEnabled: false,
});
export interface WebConfig {
  graphqlAPI: string;
  appUrl: string;
  communityUrl: string;
  communityAdminUrl: string;
  diagnosticUrl: string;
  rudderstackURL: string;
  rudderstackWriteKeyWebApp: string;
  revision: string;
  oauthAppleRedirectUrl: string;
  oauthGoogleRedirectUrl: string;
  oauthLinkedinRedirectUrl: string;
  hubspotPortalId: string;
  API: string;
  environment: string;
  growthbookKey: string;
  googleApiKey: string;
  /**
   * Server-side `LIVE_AVATAR_COACH_ENABLED`. The AI coach launcher MUST be
   * gated on this: the server kill-switch only makes the session mutation
   * throw, so without this the switch leaves a visible button that errors on
   * click. Defaults to false, so a config load that fails or predates the
   * field hides the launcher rather than showing a broken one.
   */
  liveAvatarCoachEnabled: boolean;
}

export const useConfig = () => useContext(ConfigContext);
